import React from "react";
import { FaRegComment } from "react-icons/fa";
import { motion } from "framer-motion";
import AwardsSlider from "../../component/slidercomponent/AwardsSlider";

const AwardsBanner = () => {
  return (
    <>
      <AwardsSlider />
    </>
  );
};

export default AwardsBanner;
